/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYOUT_LIST
 */
export const getPayoutReportQueryParams = zod.object({
  "dateBasis": zod.enum(['Paid', 'RequestCreated', 'Completed']).optional(),
  "startDate": zod.string().datetime({}).optional(),
  "endDate": zod.string().datetime({}).optional(),
  "sourceTypes": zod.array(zod.string()).optional(),
  "payeeType": zod.enum(['User', 'Organization']).optional(),
  "payeeId": zod.string().uuid().optional()
})

export const getPayoutReportResponse = zod.object({
  "dateBasis": zod.enum(['Paid', 'RequestCreated', 'Completed']),
  "startDate": zod.string().datetime({}),
  "endDate": zod.string().datetime({}),
  "grandTotal": zod.number(),
  "groups": zod.array(zod.object({
  "payee": zod.object({
  "type": zod.enum(['User', 'Organization']),
  "id": zod.string().uuid()
}),
  "name": zod.string(),
  "classification": zod.string().nullish(),
  "subtotal": zod.number(),
  "deposits": zod.array(zod.object({
  "reference": zod.string(),
  "settledDate": zod.string().datetime({}),
  "amount": zod.number(),
  "subtotal": zod.number(),
  "lines": zod.array(zod.object({
  "invoiceNumber": zod.number().nullish(),
  "sourceType": zod.string(),
  "description": zod.string().nullish(),
  "customer": zod.string().nullish(),
  "address": zod.string().nullish(),
  "jobType": zod.string().nullish(),
  "jobReference": zod.string().nullish(),
  "completedDate": zod.string().datetime({}).nullish(),
  "requestCreatedDate": zod.string().datetime({}),
  "requestedBy": zod.string().nullish(),
  "approvedDate": zod.string().datetime({}).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvalMethod": zod.enum(['Administrator', 'PreApproved', 'AutoApproved']).optional(),
  "gross": zod.number(),
  "fee": zod.number(),
  "net": zod.number()
}))
}))
}))
})

